'use client';

import React, { useEffect, useState } from 'react';

import Tab from '@mui/material/Tab/Tab';
import Tabs from '@mui/material/Tabs/Tabs';
import classNames from 'classnames';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';

import { Container } from '@/blocks/components/Container';
import tabsStyles from '@/blocks/components/Controls/Tabs/styles.module.scss';
import { DeprecatedTabsOverflowContainer } from '@/blocks/components/DeprecatedTabs';
import styles from '@/blocks/components/RankingCards/styles.module.scss';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import contexts from '@/styles/contexts.module.scss';

import { RankingCardsPropsCategory } from './index';

export function RankingCardsSliderWithTabs(props: {
  categories: Omit<RankingCardsPropsCategory, 'sort'>[];
  children: JSX.Element[];
}) {
  const categories = props.categories;
  const breakpoint = useBreakpoint();
  const [selectedCategory, setSelectedCategory] = useState(categories[0].value);
  const [swiper, setSwiper] = useState<SwiperClass>();
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const renderSlider = breakpoint && breakpoint !== 'desktop';
  const renderRow = breakpoint && breakpoint === 'desktop';

  return (
    <>
      <DeprecatedTabsOverflowContainer>
        <Tabs
          onChange={(_, tab) => {
            setSelectedCategory(tab);
            swiper?.slideTo(tab);
          }}
          variant={'scrollable'}
          className={classNames(tabsStyles.tabs, styles.tabs, contexts.dark)}
          value={selectedCategory}
        >
          {categories.map((c) => {
            return <Tab key={c.value} value={c.value} disableRipple label={c.label} />;
          })}
        </Tabs>
      </DeprecatedTabsOverflowContainer>

      {renderRow ? (
        <Container>
          <div className={styles.cardsRow}>{props.children}</div>
        </Container>
      ) : null}

      {renderSlider ? (
        <div style={{ opacity: isLoaded ? 1 : 0, transition: 'opacity 0.3s' }}>
          <Swiper
            className={styles.slider}
            onSwiper={setSwiper}
            slidesPerView={1.1}
            centeredSlides={true}
            spaceBetween={8}
            speed={400}
            onSlideChange={(swiper) => {
              setSelectedCategory(swiper.activeIndex);
            }}
          >
            {props.children.map((card, i) => {
              return (
                <SwiperSlide key={i} className={styles.slide}>
                  {card}
                </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      ) : null}
    </>
  );
}
